module.exports = __webpack_public_path__ + "img/1.3369f5b.png";